export const disclaimer = {
  /**
   * @method GET Listar os disclaimers do escritorio cadastrados
   * @param {String} page pagina_referencia. Query params
   */
  manage: '/v2/api/professional/disclaimer',
}

export const report = {
  user: '/v2/api/general/user-report',
}

export const office = {
  /**
   * Gerenciar parametros especificos do escritório.
   * Focado na parte do Comissionamento/Tesouraria/BPO
   */
  parameters: '/v2/api/aawz-financial-bpo/bpo-escritorio-parametros',
}

export const internalUsers = {
  // listar os profissionais da aawz
  get: `/v2/api/general/internal/users`,
}
